import { useEffect } from "react";
import { getEmptyImage } from "store/features/memeGenerator/utils/getEmptyImage";
import { useMemeEditor } from "../MemeEditorContext";

export const usePreview = () => {
    const { canvasContainerRef } = useMemeEditor();
    useEffect(() => {
        /**
         * This is being called here so that on initial drag or resize the browser doesnt show a fallback icon
         * as it will not be loaded by then
         */
        getEmptyImage();
    }, []);
    return { canvasContainerRef };
};
